<form class="form-horizontal">
	<div class="form-group">
		<label class="col-sm-2 col-lg-2 control-label">SMS/MMS Provider Name</label>
		<div class="col-md-4 col-lg-3">
			<input type="text" [(ngModel)]="email.EmailSMSProviderName" name="ProviderName" class="form-control" />
		</div>
	</div>

	<div class="form-group">
		<label class="col-sm-2 col-lg-2 control-label"> SMS/MMS Provider Address</label>
		<div class="col-md-4 col-lg-3">
			<input type="text" [(ngModel)]="email.EmailSMSProviderEmailInfo" name="ProviderAddress" class="form-control" />
		</div>
	</div>

	<div id="SaveErrorMessage" *ngIf="SaveErrorMessage" class="alert alert-danger">
		{{ SaveErrorMessage }}
	</div>

	<div class="form-group">
		<label class="col-sm-4 control-label"></label>
		<div class="col-sm-8 col-md-6 col-lg-8">
			<div name="Saveing" style="display: none" class="alert alert-info">Saving.Please wait...</div>
			<button name="btnSaving" class="btn btn-primary" type="button" (click)="EmailUpdate()">Add</button>
			&nbsp;
			<button class="btn btn-default" type="button" (click)="Cancel()">Close</button>
		</div>
	</div>
</form>
<!-- 
                </div>
            </div>
        </div>

    </div>

</div> -->
